import React from 'react'

const team1 = require('../../assets/img/Leopoldo_Navarrete.jpg'); // with require
const team2 = require('../../assets/img/Luis_Gavidia.jpg'); // with require
const team3 = require('../../assets/img/Rodrigo_Ortiz.jpg'); // with require

function Team() {
    return (
        <section className="text-gray-600 body-font">
            <div className="container px-5 py-5 mx-auto">
                <div className="flex flex-col text-center w-full mb-10">
                    <h1 className="text-2xl font-medium title-font mb-4 blue-654C tracking-widest">NUESTRO EQUIPO:</h1>
                    {/* <p className="lg:w-2/3 mx-auto leading-relaxed text-base">Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them.</p> */}
                </div>
                <div className="flex flex-wrap -m-3">
                    <div className="p-4 lg:w-1/3">
                        <div className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
                            <img alt="Leopoldo Navarrete" className="flex-shrink-0 rounded-lg w-30 h-30 object-cover object-center sm:mb-0 mb-4" src={team1} />
                                <div className="flex-grow sm:pl-8">
                                    <h2 className="title-font font-bold text-lg blue-654C">Leopoldo Navarrete</h2>
                                    <h3 className="font-medium orange-144C mb-3">Software architect & Team lead</h3>
                                    <p className="mb-4">Master en Administración de Tecnologías de Información</p>
                                </div>
                        </div>
                    </div>
                    <div className="p-4 lg:w-1/3">
                        <div className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
                            <img alt="Luis Gavidia" className="flex-shrink-0 rounded-lg w-30 h-30 object-cover object-center sm:mb-0 mb-4" src={team2} />
                                <div className="flex-grow sm:pl-8">
                                    <h2 className="title-font font-bold text-lg blue-654C">Luis Gavidia</h2>
                                    <h3 className="font-medium orange-144C mb-3">Senior Backend Developer</h3>
                                    <p className="mb-4">Master en Informática Aplicada en Redes.</p>
                                </div>
                        </div>
                    </div>
                    <div className="p-4 lg:w-1/3">
                        <div className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
                            <img alt="Rodrigo Ortiz" className="flex-shrink-0 rounded-lg w-30 h-30 object-cover object-center sm:mb-0 mb-4" src={team3} />
                                <div className="flex-grow sm:pl-8">
                                    <h2 className="title-font font-bold text-lg blue-654C">Rodrigo Ortiz</h2>
                                    <h3 className="font-medium orange-144C mb-3">Senior Full Stack Developer</h3>
                                    <p className="mb-4">Master en Informática Aplicada en Redes.</p>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Team